import {h, Fragment} from "preact"
const facets = [
  {
    name: "Clothing Size",
    values: [
      "XS", "XS/S", "S", "S/M", "M", "M/L", "L", "L/XL", "XL", "XXL", "2XL", "3XL", "ONESIZE", "24", "25", "26", "27",
      "28", "29", "30", "31", "32", "33", "0", "1", "3", "5", "7", "9", "11", "13", "15", "2T", "3T", "4T", "5/6",
      "7/8", "9/10", "One Size", "L (9/10)", "S (5/6)", "M (7/8)", "2X", "3X", "6", "SM", "6.5", "8", "OS", "10",
      "12M", "18M", "2XL/3XL", "5.5", "7.5", "8.5", "X"
    ],
  },
  {
    name: "Shoe Size",
    values: ["5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "11", "S (5/6)","M (7/8)","L (9/10)" ],
  },
  {
    name: "Category",
    values: [
      "Accessories", "Dress", "Jacket", "Jumpsuit", "Lounge & Sleepwear", "Pants", "Rompers", "Shoes", "Shorts",
      "Skirts", "Swimwear", "Tops", "Two Piece Sets"
    ],
  },
  {
    name: "Style",
    values: [
      "Accessories", "Athleisure", "Bandana", "Basic", "Bikini Bottom", "Bikini Top", "Blanket", "Blazer", "Blouse",
      "Bodycon Dress", "Bodysuit", "Boots", "Bottoms", "Bra Top", "Bracelet", "Cardigan", "Coat", "Cropped",
      "Denim Jacket", "Denim Shorts", "Earrings", "Flats", "Graphic Sweatshirt", "Graphic Tee", "Halter", "Hat",
      "Heels", "Hoodie", "Jacket", "Jeans", "Jogger", "Jumpsuit", "Kimono", "Leggings", "Lounge & Sleep Bottoms",
      "Lounge & Sleep Sets", "Lounge & Sleep Tops", "Maternity Friendly", "Maxi Dress", "Maxi Skirt", "Midi Dress",
      "Midi Skirt", "Mini Dress", "Mini Skirt", "Mommy And Me", "Necklace", "One Piece Swim", "Overalls", "Pajama Pants",
      "Pajama Shorts", "Pajama Top", "Poncho", "Puffer", "Pullover", "Purses and Bags", "Ring", "Robe", "Romper",
      "Sandals", "Shacket", "Shirt", "Shorts", "Skort", "Slippers", "Sneakers", "Sunglasses", "Sweater", "Sweater Dress",
      "Sweatshirt", "Tank", "Tumbler", "Turtleneck", "Two Piece Set", "Vest", "Wedges"
    ],
  },
  {
    name: "Color",
    values: [
      "Pink", "White", "Blue", "Black", "Green", "Orange", "Red", "Purple", "Beige", "Multi", "Brown", "Grey",
      "Yellow", "Taupe", "Gold", "Silver"
    ],
  },
  {
    name: "Sleeve Length",
    values: ["3/4 Sleeve", "Long Sleeve", "Short Sleeve", "Sleeveless", "Strapless"],
  },
  {
    name: "Price",
    values: ["$1 - $10", "$10 - $25", "$25 - $50", "$50 - $75", "$75 - $100"],
  },
  {
    name: "Print",
    values: [
      "Acid Wash", "American Flag", "Animal Print", "Camo", "Checkered", "Colorblock", "Floral", "Gingham",
      "Hearts", "Herringbone", "Houndstooth", "Leopard", "Metallic", "Paisley", "Patchwork", "Plaid", "Polka Dots",
      "Smiley Face", "Snakeskin", "Solid", "Spotted", "Stars", "Stripes", "Tie Dye", "Tropical"
    ],
  },
  {
    name: "Wash",
    values: [
      "Acid Wash", "Black", "Dark Wash", "Light Wash", "Medium Wash", "Medium wash", "White"
    ],
  },
  {
    name: "Beauty",
    values: ["Lip", "Eye", "Body", "Face", "Tools"],
  },
];

export default facets;